export default {
  setStatus (state, newvalue) {
    state.status = newvalue
  },
  setPartner (state, newvalue) {
    state.isPartner = newvalue
  },
  setPartnerStatus (state, newvalue) {
    state.partnerStatus = newvalue
  },
  setIdentStatus (state, newvalue) {
    state.identStatus = newvalue
  },
  setIsPartner (state, newvalue) {
    state.identIsPartner = newvalue
  },
  setIdentStatusPartner (state, newvalue) {
    state.identPartnerStatus = newvalue
  }
}
